module.exports = __webpack_public_path__ + "media/images/sidebar-4-742e839b462cec676577b6333d45a775.jpg";